import React, {useEffect, useState} from 'react';
import {Navigate, useLocation, useNavigate} from 'react-router-dom';
import {useAuth} from "../../context/AuthContext";
import Advertisers from "../../pages/Advertisers";

const DefaultRoute = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (loading) return;

    if (!user) {
      navigate('/login', { replace: true });
      return;
    }

    const targetPath = '/';

    // Проверяем, не находимся ли уже на целевой странице
    if (location.pathname !== targetPath) {
      navigate(targetPath, { replace: true });
    }
  }, [loading, user, navigate, location]);

  // Показываем загрузку пока не определим куда направить
  if (loading || !user) {
    return <div>Загрузка...</div>;
  }

  // Возвращаем нужную страницу в зависимости от analytics_view
  return <Advertisers /> ;
};

const ProtectedRoute = ({
  children,
  redirectDefault = false
}) => {
  const { user, loading } = useAuth();

  if (loading) return <div>Загрузка...</div>;

  // Проверка прав - используем user из контекста
  const hasAccess = () => {
    if (!user) return false;
    
    const userRole = user.role?.toString().trim().toLowerCase();
    const allowedRoles = ['root', 'admin', 'manager'];
    if (!allowedRoles.includes(userRole)) {
      return false;
    }
    
    return true;
  };

  // Если требуется перенаправление на основную страницу
  if (redirectDefault) {
    return <DefaultRoute />;
  }

  if (!hasAccess()) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;

